import { Component, OnInit, Output,EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import {OrderByPipe} from 'ngx-pipes';
import{LoopBackAuth, validacionService, pensumService, calificacionService, ActividadService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';

@Component({
  selector: 'tabla-calificacion-comportamiento',
  templateUrl: './tabla-calificacion-comportamiento.component.html',
  providers:[OrderByPipe,LoopBackAuth, validacionService,pensumService, calificacionService, ActividadService, MessageService, ]
})
export class TablaCalificacionComportamientoComponent implements OnInit {
  @Input() idMatricula
  @Input() esDueno: any
  @Input() tipoAsignatura : any  = 1
  @Input() verAsignatura : any  = 1
  @Input() spinner: any
  @Input() deuda: any
  @Output() emittNivel= new EventEmitter()
  @Output() emittTieneAsignaturas= new EventEmitter()

  search: any
  materias: any
  tareas: any
  arbol:any
  nodo: any
  nivel: any = 0

  constructor(
    private orderBy: OrderByPipe,
    private ActividadService: ActividadService,
    private calificacionService: calificacionService,
    private pensumService:pensumService,
    public val: validacionService,
  ) { }

  ngOnInit() {

  }

  ngOnChanges(changes:SimpleChanges) {
    if(changes.idMatricula != undefined
      && changes.idMatricula.currentValue != undefined)
        this.arbolHorizonta(changes.idMatricula.currentValue)
  }



  imprimirNota(calificacion, tarea){
    if(tarea.nivel == 3 && calificacion.actividad_activa != null && tarea.aca_actividad_tipo_id != 0){
      let index  = calificacion.actividad_activa.split(",").findIndex(x=> x == tarea.orden)
      return  (index >= 0) ? (calificacion.nota == null ) ? ' ': calificacion.calificacion_texto :  'x'
    }else{
      return calificacion.calificacion_texto
    }
  }

  arbolHorizonta(idMatricula){
    this.spinner.isSpinnerVisible = true
    this.pensumService.asignaturasPensum(idMatricula, this.verAsignatura).subscribe(
      materias =>{
        if(this.tipoAsignatura == 3) console.log("Ver pensum Asistencia", materias)
        if(materias && materias.length > 0){
          console.log("materias", materias)
          this.ActividadService.arbolAsignatura(idMatricula, this.tipoAsignatura).subscribe(
            actividades =>{
              if(actividades){
                  //if(this.tipoAsignatura == 3) console.log("actividades Asistencias 3", actividades)

                  this.arbol = this.val.construirArbol(actividades)
                console.log('actividades', actividades,'arbol-->',this.arbol, this.tipoAsignatura);
                  //if(this.tipoAsignatura == 3) console.log("actividades Asistencias arbol 3", this.arbol)
                  this.calificacionService.calificacionAsignatura(this.idMatricula, this.tipoAsignatura).subscribe(
                    calificaciones =>{

                        if(calificaciones){
                          this.val.construirNotas(this.arbol, materias, calificaciones, 1, 1)
                          this.materias = this.arbol[0].notas;

                          //if(this.tipoAsignatura == 3) console.log("materias  ###-->", this.materias);
                          if(this.tipoAsignatura == 4) this.tareas = this.arbol;
                          if(this.tipoAsignatura != 4) this.tareas = this.unirParciales();
                          console.log("tareas PPP", this.tareas);
                          if(this.tipoAsignatura == 3)
                            this.spinner.isSpinnerVisible = false
                        }
                    }
                  )
              }
            }
          )
        }else{
          this.emittTieneAsignaturas.emit(false)
        }
      }
    )
  }

  unirParciales(){
    let tareas  = []
    for(let nodo of this.arbol){
      for(let item of nodo.children){
        tareas.push(item)
      }
    }
    return tareas
  }

  regresar(){
    this.nivel = this.nivel-1
    this.emittNivel.emit(this.nivel)

    if(this.nivel != 0){
      this.nodo = this.val.buscarNodo(this.arbol,this.nodo.nodoPapa,0,this.nivel)
      this.tareas =  this.orderBy.transform( this.nodo.children,'orden')

      let sessionNivel = {
        nivel: this.nivel,
        nodo:this.nodo
      }
      sessionStorage.setItem('nivel_asignaturas', JSON.stringify(sessionNivel))
    }else{
      let sessionNivel = {
        nivel: 0,
        nodo:null
      }
      sessionStorage.setItem('nivel_asignaturas', JSON.stringify(sessionNivel))
      this.tareas =  this.orderBy.transform( this.arbol,'orden')
    }
  }

  siguienteNivel(nivel, idNodo){
    this.nivel = nivel

    this.emittNivel.emit(this.nivel)
    this.nodo = this.val.buscarNodo(this.arbol,idNodo,0,nivel)

    let sessionNivel = {
      nivel: this.nivel,
      nodo:this.nodo
    }
    sessionStorage.setItem('nivel_asignaturas', JSON.stringify(sessionNivel))
    this.tareas =  this.orderBy.transform(this.nodo.children,'orden')
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/tabla-calificacion-comportamiento.component.ts